declare namespace $ {

	type $shm_list_head__title_shm_service_task_list_1 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['title'] >
		,
		ReturnType< $shm_list_head['title'] >
	>
	type $shm_list_head__filter_shm_service_task_list_2 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['filter'] >
		,
		ReturnType< $shm_list_head['filter'] >
	>
	type $shm_list_head__add_shm_service_task_list_3 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add'] >
		,
		ReturnType< $shm_list_head['add'] >
	>
	type $shm_list_head__add_enabled_shm_service_task_list_4 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add_enabled'] >
		,
		ReturnType< $shm_list_head['add_enabled'] >
	>
	type $shm_list_head__sort_by_shm_service_task_list_5 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['sort_by'] >
		,
		ReturnType< $shm_list_head['sort_by'] >
	>
	type $shm_list_head__sort_order_shm_service_task_list_6 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['sort_order'] >
		,
		ReturnType< $shm_list_head['sort_order'] >
	>
	type $shm_list_head__sort_options_shm_service_task_list_7 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['sort_options'] >
		,
		ReturnType< $shm_list_head['sort_options'] >
	>
	type $shm_list_head__sort_content_shm_service_task_list_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_head['sort_content'] >
	>
	type $shm_list_head__Close_shm_service_task_list_9 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_list_head['Close'] >
	>
	type $mol_list__rows_shm_service_task_list_10 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__title_shm_service_task_list_11 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_service_task_list_12 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_service_task_list_13 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_service_task_list_14 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_title_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_service_task_list_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_service_task_list_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_service_task_menu__pin_enabled_shm_service_task_list_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_service_task_menu['pin_enabled'] >
	>
	type $shm_service_task_menu__archive_enabled_shm_service_task_list_18 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_service_task_menu['archive_enabled'] >
	>
	type $shm_service_task_menu__pinned_shm_service_task_list_19 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_pinned'] >
		,
		ReturnType< $shm_service_task_menu['pinned'] >
	>
	type $shm_service_task_menu__archived_shm_service_task_list_20 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_archived'] >
		,
		ReturnType< $shm_service_task_menu['archived'] >
	>
	type $mol_link__arg_shm_service_task_list_21 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__uri_off_shm_service_task_list_22 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_uri'] >
		,
		ReturnType< $mol_link['uri_off'] >
	>
	type $mol_link__title_shm_service_task_list_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_service_task_list_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__current_shm_service_task_list_25 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__event_shm_service_task_list_26 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $shm_service_task_list['task_open'] > ): ReturnType< $shm_service_task_list['task_open'] >,
		})  & ReturnType< $mol_link['event'] >
		,
		ReturnType< $mol_link['event'] >
	>
	type $mol_link__attr_shm_service_task_list_27 = $mol_type_enforce<
		({ 
			'shm_service_task_new': ReturnType< $shm_service_task_list['task_is_new'] >,
		})  & ReturnType< $mol_link['attr'] >
		,
		ReturnType< $mol_link['attr'] >
	>
	type $mol_view__sub_shm_service_task_list_28 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['task_marker_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_service_task_list_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_service_task_list_30 = $mol_type_enforce<
		({ 
			'current': ReturnType< $shm_service_task_list['task_current'] >,
			'archived': ReturnType< $shm_service_task_list['task_archived'] >,
			'pinned': ReturnType< $shm_service_task_list['task_pinned'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_service_task_list_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_service_task_list_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_sort__sort_by_shm_service_task_list_33 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['sort_by'] >
		,
		ReturnType< $shm_sort['sort_by'] >
	>
	type $shm_sort__sort_order_shm_service_task_list_34 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['sort_order'] >
		,
		ReturnType< $shm_sort['sort_order'] >
	>
	type $shm_sort__options_shm_service_task_list_35 = $mol_type_enforce<
		ReturnType< $shm_service_task_list['sort_options'] >
		,
		ReturnType< $shm_sort['options'] >
	>
	export class $shm_service_task_list extends $mol_page {
		filter( next?: string ): string
		add( next?: any ): any
		sort_by( next?: string ): string
		sort_order( next?: string ): string
		sort_options( ): Record<string, string>
		List_head( ): $shm_list_head
		Tasks( ): $mol_list
		Add_foot( ): $mol_button_major
		task_arg( id: any): Record<string, any>
		task_uri( id: any): string
		task_title_rows( id: any): readonly(any)[]
		Task_title_row( id: any): $mol_view
		task_meta( id: any): string
		Task_meta( id: any): $mol_view
		Task_info( id: any): $mol_view
		task_current( id: any): boolean
		task_open( id: any, next?: any ): any
		task_is_new( id: any): boolean
		task_marker_rows( id: any): readonly(any)[]
		task_title( id: any): string
		task_archived( id: any, next?: boolean ): boolean
		task_pinned( id: any, next?: boolean ): boolean
		Task_menu( id: any): $shm_service_task_menu
		title( ): string
		add_title( ): string
		add_enabled( ): boolean
		task_rows( ): readonly($mol_view)[]
		head( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		Task_link( id: any): $mol_link
		Task_markers( id: any): $mol_view
		Task_title( id: any): $mol_view
		Task_row( id: any): $mol_view
		Empty( ): $mol_view
		Sort( ): $shm_sort
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map